import { FilterField } from '@totem/components/ui_components/reportSettings/types';

// Ref Type option for documents with no reference; the container maps it to the empty objectType.
export const NO_REFERENCE_LABEL = 'Organization Only';

export const documentsContainerConfiguration: FilterField[] = [
  {
    key: 'name',
    label: 'Name',
    sortField: 'document.displayName',
    filterField: 'displayName',
    multiple: false,
    operator: 'cscontains',
    values: [],
  },
  {
    key: 'version',
    label: 'Version',
    sortField: 'document.version',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'type',
    label: 'Type',
    sortField: 'document.fileType',
    filterField: 'fileType',
    multiple: true,
    values: [],
  },
  {
    key: 'size',
    label: 'Size',
    sortField: 'document.size',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'refType',
    label: 'Ref Type',
    sortField: 'document.objectType',
    filterField: 'objectType',
    multiple: true,
    values: [],
  },
  {
    key: 'refName',
    label: 'Ref Name',
    sortField: 'document.objectDisplay',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'region',
    label: 'Region',
    sortField: 'region.name',
    filterField: 'regionId',
    multiple: true,
    values: [],
  },
  {
    key: 'building',
    label: 'Building',
    sortField: 'building.name',
    filterField: 'buildingId',
    multiple: true,
    values: [],
  },
  {
    key: 'controlSystem',
    label: 'Control System',
    sortField: 'controlSystem.name',
    filterField: 'controlSystemId',
    multiple: true,
    values: [],
  },
  {
    key: 'createdBy',
    label: 'Created By',
    sortField: 'document.createdBy',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    // The repository page's "Added" column sorts by date and filters by who added the document.
    key: 'createdAt',
    label: 'Added By',
    sortField: 'document.createdAt',
    filterField: 'createdBy',
    multiple: true,
    values: [],
  },
  {
    key: 'updatedAt',
    label: 'Updated At',
    sortField: 'document.updatedAt',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    // Filters on the server's expiryState buckets: Expired / Within 90 days / Later.
    key: 'expirationDate',
    label: 'Expires',
    sortField: 'document.expirationDate',
    filterField: 'expiryState',
    multiple: true,
    values: [],
    options: [
      { text: 'Expired', value: 'Expired' },
      { text: 'Within 90 days', value: 'Within 90 days' },
      { text: 'Later', value: 'Later' },
    ],
  },
];
